import { organizationJsonLd, pageSeo, seoDefaults, websiteJsonLd } from './seo'
import { products } from './products'
import { faqs } from './faqs'
import { howItWorksSteps } from './howItWorks'
import { testimonials } from './testimonials'

const orgRef = { '@id': `${seoDefaults.siteUrl}/#organization` }

const productListJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'ItemList',
  name: 'Hydrosprings chlorine-free pool and spa systems',
  itemListElement: products.map((product, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    item: {
      '@type': 'Product',
      name: product.name,
      description: `${product.description} Fits ${product.capacity}.`,
      image: product.image,
      brand: { '@type': 'Brand', name: 'Hydrosprings' },
      category: 'Pool water purification system',
      url: `${seoDefaults.siteUrl}/shop`,
      offers: {
        '@type': 'Offer',
        availability: 'https://schema.org/InStock',
        url: `${seoDefaults.siteUrl}/shop`,
        priceCurrency: 'USD',
        availableDeliveryMethod: 'https://schema.org/OnSitePickup',
        seller: orgRef,
      },
    },
  })),
}

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: { '@type': 'Answer', text: faq.answer },
  })),
}

const howToJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'HowTo',
  name: 'How Hydro-pH-Infusion purifies pool water without chemicals',
  description:
    'The four-stage Hydrosprings process that balances pH to 7.2\u20137.6 and eliminates algae and bacteria without chlorine, salt or additives.',
  step: howItWorksSteps.map((step, index) => ({
    '@type': 'HowToStep',
    position: index + 1,
    name: step.title,
    text: step.body,
  })),
}

const reviewsJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Product',
  name: 'Hydrosprings chlorine-free pool system',
  brand: { '@type': 'Brand', name: 'Hydrosprings' },
  image: seoDefaults.ogImage,
  description: pageSeo.home.description,
  review: testimonials.map((item) => ({
    '@type': 'Review',
    reviewBody: item.quote,
    author: { '@type': 'Person', name: item.name },
    reviewRating: { '@type': 'Rating', ratingValue: 5, bestRating: 5 },
  })),
}

const contactPageJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'ContactPage',
  name: pageSeo.contact.title,
  description: pageSeo.contact.description,
  url: `${seoDefaults.siteUrl}/contact`,
  publisher: orgRef,
}

function breadcrumb(name: string, path: string) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: seoDefaults.siteUrl,
      },
      {
        '@type': 'ListItem',
        position: 2,
        name,
        item: `${seoDefaults.siteUrl}${path}`,
      },
    ],
  }
}

export const homeJsonLd = [
  { id: 'organization', data: organizationJsonLd },
  { id: 'website', data: websiteJsonLd },
  { id: 'reviews', data: reviewsJsonLd },
]

export const shopJsonLd = [
  { id: 'products', data: productListJsonLd },
  { id: 'breadcrumb-shop', data: breadcrumb('Shop systems', '/shop') },
]

export const technologyJsonLd = [
  { id: 'howto', data: howToJsonLd },
  { id: 'faq', data: faqJsonLd },
  {
    id: 'breadcrumb-technology',
    data: breadcrumb('The technology', '/technology'),
  },
]

export const contactJsonLd = [
  { id: 'contact', data: contactPageJsonLd },
  { id: 'breadcrumb-contact', data: breadcrumb('Contact', '/contact') },
]
